import { render, staticRenderFns } from "./RepresentativeCustomer.vue?vue&type=template&id=2621b5c8"
import script from "./RepresentativeCustomer.vue?vue&type=script&lang=js"
export * from "./RepresentativeCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports